import React from 'react';
import {Link} from 'react-router-dom';
import KinderWhite from "../assets/KinderWhite.svg";
import "./DesktopHeader.css";

function DesktopHeader(){
    return(
        <div
        className="header-row"
        style={{
          display: "flex",
          width: "100%",
          fontFamily: "Raleway",
          paddingTop:"1%",
          paddingLeft:"2%",
          alignItems:"space-between",
          justifyContent:"space-between",
          overflow:"hidden"
        }}
      >
      {/* <div style={{ position: "absolute", left: 40, top: 10 }}> */}
      <div style={{   

                }}>
      <a href="/">
        <img
          src={KinderWhite}
          type="image/svg+xml"
          style={{ marginLeft: "43px", width: "175px" }}
        >
          {/* <img
            src={KinderWhitePNG}
            alt="Kinder logo"
            style={{ width: "175x" }}
          /> */}
        </img>
        </a>
      </div>

      <div className="menu-links" style={{marginRight:"6%",paddingTop:"2%"}}>
        <Link to="/" style={{
            color: "white",
          }}>App</Link>
        {/* <Link to="/corporate" style={{
            color: "white",
          }}>Corporate</Link> */}
        <Link to="/Team" style={{
            color: "white",
          }}>Team</Link>
        <Link to="/Contact" style={{
            color: "white",
          }}>Contact</Link>
      </div>
      </div>
    )
}

export default DesktopHeader;